import {DeviceAlertConstant} from '../redux_constants/device.constant';
import {get_response} from "../helper/request";

export const fetchDevicesList = () => ({
    type : DeviceAlertConstant.FETCHING_DEVICES_LIST
})

export const receivedDevicesListResponse = (type, response) => ({
    type : type,
    response : response
})

export const recievedDeviceProperties = (type, response) => dispatch => {
    dispatch({
        type : type,
        response : response
    });
    return Promise.resolve();
}

export const getDevicesList = () => (dispatch) => {
    dispatch(fetchDevicesList())
    let url = `/api/device/`
    get_response(url)
        .then(response => {
            if(response.status === 200){
                dispatch(receivedDevicesListResponse(DeviceAlertConstant.RECEIVED_DEVICES_LIST, response))
            }
            else{
                dispatch(receivedDevicesListResponse(DeviceAlertConstant.FAILED_TO_RECEIVE_DEVICES_LIST, response))
            }
        })
        .catch(err => {
            dispatch(receivedDevicesListResponse(DeviceAlertConstant.FAILED_TO_RECEIVE_DEVICES_LIST, err))
            console.log(err)
        })
}

export const getDeviceProperties = (deviceId) => (dispatch) => {
    const url = "/server/devices/" + deviceId + "/settings/get_scanner_properties/";
    return new Promise((resolve, reject) => {
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    dispatch(recievedDeviceProperties(DeviceAlertConstant.RECIEVED_DEVICE_PROPERTIES, response)).then(resolve());
                }
            })
            .catch(err => {
                console.log(err);
                reject();
            });
    })
}
